<div [ngClass]="analyticsService.currentTheme === 'material-dark' ? 'dark-theme' : ''">
  <!-- <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    *ngIf="router.url.includes('teacher-classroom') && isModal"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="false"
    [zIndex]="1003"
  >
  </ngx-spinner> -->
  <!-- <div *ngIf="isModal">
    <div
      class="row"
      style="margin-top: -1rem"
      [ngClass]="!classroom ? 'mb-5' : ''"
    >
      <div class="col-md-12 d-flex justify-content-center" *ngIf="classroom">
        <nb-card class="classroom-details">
          <nb-card-body>
            <div class="d-flex justify-content-between">
              <div
                class="classroom-name-content text-left"
                style="margin-top: -10px"
              >
                <h5 class="classroom-name quicksand-bold-label">
                  {{ classroom?.name }}
                </h5>

                <div class="classroom-subject quicksand-bold-label">
                  {{ classroom?.subject | uppercase }}
                </div>
              </div>

              <div class="d-flex" style="margin-right: -5px">
                <div class="classroom-code text-center quicksand-normal-label">
                  {{ classroom?.code }}
                </div>
              </div>
            </div>
          </nb-card-body>
        </nb-card>

        <div class="btn-close-content">
          <button class="btn-close" (click)="closeDialog()">
            <nb-icon icon="collapse" class="icon-close-expand-view"></nb-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="card-details-label" *ngIf="isModal">
    Click on Students to view progress and details
  </div> -->
  <table class="table table-hover table-small mb-0 table-border-radius table-responsive">
    <thead *ngIf="usersData?.length > 0">
      <tr class="table-header-row">
        <th
          scope="col"
          class="main-header {{ isModal ? 'student-profile-content' : '' }}"
          style="text-align: start; padding: 12px 24px"
        >
          Profile <span class="mr-1">Name</span>
        </th>
        <th scope="col" class="main-header" style="text-align: start; padding: 12px 24px" *ngIf="isModal">Email</th>
        <th scope="col" class="main-header">Grade</th>
        <th scope="col" class="main-header">Ask AI</th>
        <th scope="col" class="main-header">Ask Students</th>
        <th scope="col" class="main-header">Ask Teachers</th>
        <th scope="col" class="main-header">Help Students</th>
        <th scope="col" class="main-header">Total Points</th>
        <th scope="col" class="main-header">Assessment Performance</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let user of usersData"
        class="cursor-pointer quicksand-normal-label user-data-content"
        (click)="
          studentDetails(
            user?.studentId,
            user.user_id,
            ((correctnessCount?.[user.user_id] || 0) / this.assessmentEvaluationData.teacher_assessments_total_questions.length) * 100 || 0
          )
        "
      >
        <td class="user-data-power-up-points {{ isModal ? 'student-profile-content' : '' }}">
          <div class="profile-name row">
            <div class="col-md-3">
              <!-- Default Image -->
              <img
                *ngIf="utilService.getProfileImage(user)"
                src="/assets/images/no-profile-image.png"
                alt="profile-img"
                height="35"
                width="35"
                class="profile-img mr-1"
              />

              <!-- Profile Image -->
              <img
                *ngIf="!utilService.getProfileImage(user)"
                [src]="user?.user?.user_profile_media?.image?.url"
                alt="profile-img"
                height="35"
                width="35"
                class="profile-img mr-1"
              />
            </div>
            <div class="col-md-9 mt-2">
              {{ user?.user?.firstName | titlecase }}
              {{ user?.user?.lastName | titlecase }}
            </div>
          </div>
        </td>
        <td class="user-data-power-up-points" style="text-align: start" *ngIf="isModal">
          {{ user?.user?.email }}
        </td>
        <td class="user-data-power-up-points" [ngClass]="{ 'dark-mode-text': isModal }">
          <!-- {{ user?.user?.profileData?.grades }} -->
          {{ user?.grades?.grade ? user?.grades?.grade : '-' }}
        </td>
        <td class="user-data-power-up-points ask-ai-points">
          {{ user?.powerUpPointsByAi }}
        </td>
        <td class="user-data-power-up-points ask-students-points">
          {{ user?.powerUpPointsByStudent }}
        </td>
        <td class="user-data-power-up-points ask-teachers-points">
          {{ user?.powerUpPointsByTeacher }}
        </td>
        <td class="user-data-power-up-points help-student-points">
          {{ user?.pointsByHelpingStudents }}
        </td>
        <td class="user-data-power-up-points" [ngClass]="{ 'dark-mode-text': !isModal }">
          {{ user?.total_power_up_points }}
        </td>
        <td
          class="user-data-power-up-points"
          [ngClass]="{ 'dark-mode-text': !isModal }"
          *ngIf="assessmentEvaluationData?.teacher_assessments_total_questions"
        >
          {{
            ((correctnessCount?.[user.user_id] || 0) / this.assessmentEvaluationData.teacher_assessments_total_questions.length) * 100 || 0
              | number: '1.2-2'
          }}
          %

          <nb-progress-bar
            [value]="
              ((correctnessCount?.[user?.user_id] || 0) / this.assessmentEvaluationData?.teacher_assessments_total_questions.length) *
                100 || 0
            "
            [status]="
              getStatusClass(
                ((correctnessCount?.[user.user_id] || 0) / this.assessmentEvaluationData.teacher_assessments_total_questions.length) * 100
              )
            "
          >
          </nb-progress-bar>
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="usersData?.length === 0" class="text-center no-user-found">
    <img src="/assets/images/respond-edu.svg" alt="no-data-found" height="100" width="100" />
    <br />
    <label class="quicksand-bold-label">No Users Found!</label>
  </div>

  <ng-container *ngIf="isPaginate && usersData?.length > 10">
    <div class="pagination d-flex justify-content-between">
      <div class="pt-2 align-self-baseline">
        <span class="pagination-numbers-count quicksand-bold-label"> Page {{ currentPage }} of {{ totalPages }} </span>
      </div>
      <div>
        <button class="btn-paginate mr-2 quicksand-bold-label" (click)="getUsers(false)" [disabled]="currentPage === 1">
          <label *ngIf="!storageService.detectMob()"> Previous</label>
          <nb-icon icon="arrow-back-outline" *ngIf="storageService.detectMob()"> </nb-icon>
        </button>

        <button
          class="btn-paginate quicksand-bold-label"
          (click)="getUsers(true)"
          [disabled]="currentPage === totalPages"
        >
          <label *ngIf="!storageService.detectMob()"> Next</label>
          <nb-icon icon="arrow-forward-outline" *ngIf="storageService.detectMob()"> </nb-icon>
        </button>
      </div>
    </div>
  </ng-container>
</div>
